export default __webpack_public_path__ + "static/media/image-not-found.0ea80a16.png";